import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import {
  useFloating,
  offset,
  shift,
  flip,
  autoUpdate,
  useDismiss,
  useInteractions,
} from '@floating-ui/react'
import { images } from '../services/images.service'

export function UserGreetingMenu({ user, onLogout }) {
  const [greeting, setGreeting] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const hour = new Date().getHours()
    if (hour >= 5 && hour < 12) setGreeting('בוקר טוב')
    else if (hour >= 12 && hour < 18) setGreeting('צהריים טובים')
    else if (hour >= 18 && hour < 22) setGreeting('ערב טוב')
    else setGreeting('לילה טוב')
  }, [])

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-end',
    middleware: [offset(8), shift(), flip()],
    whileElementsMounted: autoUpdate,
  })

  const dismiss = useDismiss(context)
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss])

  function toggleDropdown() {
    setIsOpen((prev) => !prev)
  }

  function handleLogout() {
    setIsOpen(false)
    onLogout()
  }

  return (
    <div className="relative flex gap-2 items-center text-right">
      <div className="flex gap-2 items-center">
        <Link to={`/user/${user.username}`}>
          <div className="w-10 aspect-square rounded-full overflow-hidden border border-primary">
            <img
              src={user.image}
              alt={user.nickname}
              className="w-full h-full object-cover"
            />
          </div>
        </Link>
        <span>{`${greeting}, ${user.nickname || user.fullname}`}</span>
      </div>

      <button
        ref={refs.setReference}
        onClick={toggleDropdown}
        {...getReferenceProps()}
        className="flex items-center gap-1 text-white hover:opacity-80 transition"
        aria-label="תפריט משתמש"
      >
        <ChevronDown className="w-4 h-4" />
      </button>

      {isOpen && (
        <div
          ref={refs.setFloating}
          style={{
            ...floatingStyles,
            borderImage: `url(${images.redBorder}) 10 stretch`,
            borderWidth: '2px',
            borderStyle: 'solid',
          }}
          {...getFloatingProps()}
          className="bg-background p-6 flex flex-col gap-5  z-50 w-40"
        >
          <Link
            to={`/user/${user.username}`}
            onClick={() => setIsOpen(false)}
            className="block hover:text-primary transition-colors text-h4 text-white"
          >
            פרופיל שלי
          </Link>
          <button
            onClick={handleLogout}
            className="w-full hover:text-primary transition-colors text-right text-h4 text-white"
          >
            התנתקות
          </button>
        </div>
      )}
    </div>
  )
}
